import React, { memo, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor';
import { useTranslation } from 'react-i18next';
import { Box, Tooltip, Typography } from '@mui/material';
import { BackspaceIcon } from '../../../../assets/icons_svg';

function Header({ isOptions = true }) {
    const { t } = useTranslation();
    const history = useHistory();

    const [theme, setTheme] = useState(null);

    useEffect(() => {
        setTheme(GetThemeColorFromStorage());
    }, []);

    const handleLogoClick = useCallback(() => {
        history.push('/');
    }, [history]);

    return (
        <Box
            width="100%"
            display="flex"
            alignItems="center"
            pt="28px"
            pr={{
                xs: "10px",
                sm: "12px",
                md: "25px",
                lg: "28px"
            }}

        >
            {/* Logo e linha divisória */}
            <Box
                flexGrow={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                pl={{ xs: "16px", sm: "16px", md: "73px", lg: '73px' }}
            >
                <Box
                    maxWidth="782px"
                    width="100%"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap="28px">
                    <Box
                        component="img"
                        src={theme?.images?.loginPage?.logo?.url}
                        alt={theme?.images?.loginPage?.logo?.filename ?? 'Logo'}
                        sx={{ cursor: 'pointer', width: 'fit-content', maxWidth: "200px" }}
                        onClick={handleLogoClick}
                    />
                    {isOptions && (<Box width="100%" height="1px" bgcolor="#C4C4C4" maxWidth="800px" />)}
                </Box>
            </Box>

            {/* Botão de voltar */}
            {isOptions && (
                <Tooltip
                    title={
                        <Typography variant="body2" textAlign="center">
                            Voltar para <br /> o login
                        </Typography>
                    }
                    placement="bottom"
                    arrow
                    componentsProps={{
                        popper: {
                            sx: {
                                '& .MuiTooltip-tooltip': {
                                    backgroundColor: "#000000",
                                    borderRadius: '7px',
                                    padding: '8px 13px',
                                },
                                '& .MuiTooltip-arrow': {
                                    color: "#000000",
                                },
                            },
                        },
                    }}>
                    <Box
                        width={{
                            xs: '30px',
                            sm: '30px',
                            md: "45px",
                        }}
                        height={{
                            xs: '30px',
                            sm: '30px',
                            md: "45px",
                        }}
                        cursor='pointer'
                        bgcolor="#F2F2F2"
                        borderRadius="50%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center">
                        <BackspaceIcon
                            onClick={handleLogoClick}
                            sx={{
                                color: theme?.visual?.icons?.color,
                                fontSize: { xs: '14px', sm: '14px', md: '18px' },
                                cursor: 'pointer',
                            }}
                        />
                    </Box>
                </Tooltip>
            )}


        </Box>
    );
}

export default memo(Header);
